import { render } from "./SelecionarCamposRelatorioPCP.vue?vue&type=template&id=75abcbaa&scoped=true&ts=true"
import script from "./SelecionarCamposRelatorioPCP.vue?vue&type=script&lang=ts"
export * from "./SelecionarCamposRelatorioPCP.vue?vue&type=script&lang=ts"

import "./SelecionarCamposRelatorioPCP.vue?vue&type=style&index=0&id=75abcbaa&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75abcbaa"]])

export default __exports__